import React from "react";
import { Route, withRouter } from "react-router-dom";
import { inject } from "mobx-react";
import { useQuery } from "@apollo/client";
import { NEWS_ONE } from "Services/queries";
import HeaderWrapperContainer from "Containers/HeaderWrapperContainer";
import { useParams } from "react-router-dom";
import { Loading } from "ComponentsUI/Loading";
import { Redirect404 } from "ComponentsUI/Redirects";
import useDefaultParams from "Services/useDefaultParams";

const Wrapper = (props) => {
	let {
		mainComponent: MainComponent,
		seoData,
		ApplicationModel: { routesModel },
	} = props;

	const routeParams = useParams();
	const { regionUrl } = useDefaultParams(routeParams);

	let newsOneQuery = useQuery(NEWS_ONE, {
		variables: {
			id: parseInt(props.rest.match.params.newsId),
			region_url: regionUrl,
		},
	});
	if (newsOneQuery.loading) {
		return <Loading />;
	}

	let newsOne = newsOneQuery?.data?.newsOne || null;
	if (!newsOne) {
		return <Redirect404 message404={"newsOne пустой"} />;
	}
	routesModel.setCurrentNews(newsOne);
	return (
		<HeaderWrapperContainer seoData={seoData} withoutBackground={true} darkBackground={true}>
			<MainComponent newsOne={newsOne} />
		</HeaderWrapperContainer>
	);
};

const ActionLayout = ({ component: Component, seoData, ApplicationModel, ...rest }) => {
	return (
		<Route
			{...rest}
			render={() => {
				return (
					<Wrapper
						seoData={seoData}
						rest={rest}
						mainComponent={Component}
						ApplicationModel={ApplicationModel}
					/>
				);
			}}
		/>
	);
};

export default withRouter(inject("ApplicationModel")(ActionLayout));
